import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { SelectField, DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import ReactTable from 'Common/ReactTableWrapper';
import { NotificationDialog, LoadingPage } from 'Components';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { ManagePurchaseOrderEnum, FilterEnum } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { MANAGE_PURCHASE_ORDER_FORM_NAME } from 'Common/FormEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import {
  ReceiptTypeEnum,
  PrintTypeEnum,
} from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';
import { DatePickerCustomButton } from 'Components';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { SiteComponent } from 'Common/SiteComponent';

const ManagePurchaseOrderComponent = props => {
  const viewStatusOptions = [
    { value: ManagePurchaseOrderEnum.All, label: 'All' },
    { value: ManagePurchaseOrderEnum.Open, label: 'Open' },
    { value: ManagePurchaseOrderEnum.Closed, label: 'Closed' },
  ];
  const sortOptions = [
    { value: ManagePurchaseOrderEnum.ItemCode, label: 'Item Code' },
    { value: ManagePurchaseOrderEnum.Description, label: 'Item Description' },
  ];

  const printOptions = [
    { value: PrintTypeEnum.Order, label: 'Order' },
    { value: PrintTypeEnum.Receipt, label: 'Receipt' },
  ];

  const viewReceiptOptions = [
    { value: ReceiptTypeEnum.ALL, label: 'All' },
    { value: ReceiptTypeEnum.WITH_ORDERS, label: 'With Orders' },
    { value: ReceiptTypeEnum.WITHOUT_ORDERS, label: 'Without Orders' },
  ];

  const {
    columns,
    reactTable,
    purchaseOrderListData,
    onChangeOfFromDT,
    fromDateMax,
    toDateMin,
    onChangeOfToDT,
    assignItemsVendorData,
    handleVendorChange,
    setShowStatusOption,
    clearFilters,
    setShowReceiptOption,
    showCloseModel,
    handleCloseDialog,
    showCloseConfirm,
    closeOrderConfirm,
    loading,
    closing,
    printOrderReceipt,
    printLoading,
    isContainWO,
    handleEleFileDownload,
    eleFileDownloadMsg,
    handleEleFileMsgDialog,
    checkPrintType,
    handlePrintClick,
    showDeleteConfirm,
    closeDeleteOrderConfirm,
    showDeleteModel,
    handleDeleteDialog,
    selectedOrder,
    deletePOWOReceiptLoading,
    gridPreferenceLoading,
    gridPreferenceSubmitting,
    handleClick,
    activeIndexes,
    handleSiteChange,
  } = props;

  const vendorData = makeOptionsData(assignItemsVendorData);

  let deleteQuestion =
    'Are you sure you would like to permanently delete all checked orders?';
  if (selectedOrder && selectedOrder[ManagePurchaseOrderEnum.Receipt]) {
    deleteQuestion = `Are you sure you would like to permanently delete order with receipt# ${
      selectedOrder[ManagePurchaseOrderEnum.Receipt]
      } ?`;
  }
  let message = 'Please only select Purchase Orders to create Electronic File';
  if (showCloseConfirm) {
    message = 'Please only select open orders to close.';
  } else if (eleFileDownloadMsg) {
    message = eleFileDownloadMsg;
  }
  let question = showDeleteModel
    ? deleteQuestion
    : 'Closing a Purchase Order will set all related open receipt item quantities to “0”. Both the Purchase Order and related receipt(s) will be set to a closed status.\n' +
    '     Are you Sure?';

  return printLoading || closing ? (
    <LoadingPage />
  ) : (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndexes.indexOf(0) !== -1}
            index={0}
            option={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
            <Grid className="gridspacing">
              <Grid.Row columns={2}>
                <Grid.Column>
                  <div className="paddingTop25">
                    <Header as="h4">Delivery/Receipt Date Range</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'From:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={ManagePurchaseOrderEnum.BeginDT}
                    onChange={onChangeOfFromDT}
                    maxDate={fromDateMax}
                    type={'text'}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'To:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={ManagePurchaseOrderEnum.EndDT}
                    type={'text'}
                    onChange={onChangeOfToDT}
                    minDate={toDateMin}
                    dropdownMode="select"
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field
                    name={FilterEnum.VendorId}
                    component={SelectField}
                    type={'text'}
                    options={vendorData}
                    label={'Distributor'}
                    onChange={handleVendorChange}
                  />
                </Grid.Column>
                <Grid.Column>
                  <SiteComponent
                    name={FilterEnum.SiteId}
                    isForm={true}
                    label={'Site'}
                    isAllRequired={true}
                    showAllActiveSites={true}
                    isAllValueZero={true}
                    onChange={handleSiteChange}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column className="paddingTop25" width={5}>
                  <div>
                    <Header as="h4">View Status</Header>
                  </div>
                </Grid.Column>
                <Grid.Column className="paddingTop25" width={8}>
                  <div>
                    <Header as="h4">Show Receipts</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3}>
                <Grid.Column width={5}>
                  <ReduxFormButtonGroup
                    options={viewStatusOptions}
                    type={'button'}
                    formName={MANAGE_PURCHASE_ORDER_FORM_NAME}
                    fieldName={ManagePurchaseOrderEnum.ViewStatusOptions}
                    onChange={setShowStatusOption}
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <ReduxFormButtonGroup
                    options={viewReceiptOptions}
                    type={'button'}
                    formName={MANAGE_PURCHASE_ORDER_FORM_NAME}
                    fieldName={ManagePurchaseOrderEnum.ViewReceiptOptions}
                    onChange={setShowReceiptOption}
                  />
                </Grid.Column>
                <Grid.Column width={3}>
                  <Button
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndexes.indexOf(1) !== -1}
            index={1}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Print</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
            <Grid>
              <Grid.Row>
                <Grid.Column className="paddingTop25" width={5}>
                  <div>
                    <Header as="h4">Sort By</Header>
                  </div>
                </Grid.Column>
                <Grid.Column className="paddingTop25" width={8}>
                  <div>
                    <Header as="h4">Print Type</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3} className={'pt10'}>
                <Grid.Column width={5} verticalAlign={'bottom'}>
                  <ReduxFormButtonGroup
                    options={sortOptions}
                    formName={MANAGE_PURCHASE_ORDER_FORM_NAME}
                    fieldName={ManagePurchaseOrderEnum.SortOptions}
                    type={'button'}
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <ReduxFormButtonGroup
                    options={printOptions}
                    formName={MANAGE_PURCHASE_ORDER_FORM_NAME}
                    fieldName={ManagePurchaseOrderEnum.PrintOptions}
                    type={'button'}
                  />
                </Grid.Column>
                <Grid.Column width={3}>
                  <Button
                    content="Print"
                    type={'button'}
                    onClick={printOrderReceipt}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                reactTableRef={reactTable}
                defaultPageSize={20}
                showPageSizeOptions={true}
                minRows={0}
                data={purchaseOrderListData.GetData}
                noDatatext={'No Orders found'}
                resizable={false}
                className="-striped -highlight modalGrid"
                columns={columns}
                draggableColumns={true}
                showHideColumn={true}
                menu={'hasCogs'}
                saveState={{
                  tableName: TableNamesEnum.PURCHASE_ORDER_TABLE,
                }}
                loading={
                  loading ||
                  deletePOWOReceiptLoading ||
                  gridPreferenceLoading ||
                  gridPreferenceSubmitting
                }
                hasSelectAllColumn={true}
                gridName={GridEnum.INV_ManagePurchaseOrder_View}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <YesNoDialog
          showDialog={showDeleteModel || showCloseModel}
          title={showDeleteModel ? 'Delete Order ' : 'Close Order'}
          question={question}
          yesCallback={() => {
            showDeleteModel
              ? handleDeleteDialog(true)
              : handleCloseDialog(true);
          }}
          noCallback={() => {
            showDeleteModel
              ? handleDeleteDialog(false)
              : handleCloseDialog(false);
          }}
        />
        <NotificationDialog
          title={'Manage Orders'}
          showDialog={
            showDeleteConfirm ||
            showCloseConfirm ||
            isContainWO ||
            eleFileDownloadMsg > ''
          }
          message={message}
          onOkClick={
            showDeleteConfirm
              ? closeDeleteOrderConfirm
              : showCloseConfirm
              ? closeOrderConfirm
              : isContainWO
                ? handleEleFileDownload
                : handleEleFileMsgDialog
          }
        />
        <NotificationDialog
          title={'Manage Orders'}
          showDialog={checkPrintType}
          message={
            'Please select Receipt from Print type to print receipt without orders.'
          }
          onOkClick={handlePrintClick}
        />
      </Form>
    </Fragment>
  );
};
ManagePurchaseOrderComponent.propTypes = {
  assignItemsVendorData: PropTypes.array,
  checkPrintType: PropTypes.bool,
  clearFilters: PropTypes.func,
  closeDeleteOrderConfirm: PropTypes.func,
  closeOrderConfirm: PropTypes.func,
  closing: PropTypes.bool,
  columns: PropTypes.array,
  deletePOWOReceiptLoading: PropTypes.bool,
  eleFileDownloadMsg: PropTypes.string,
  fromDateMax: PropTypes.object,
  gridPreferenceLoading: PropTypes.bool,
  gridPreferenceSubmitting: PropTypes.bool,
  handleVendorChange: PropTypes.func,
  handleCloseDialog: PropTypes.func,
  handleDeleteDialog: PropTypes.func,
  handleEleFileDownload: PropTypes.func,
  handleEleFileMsgDialog: PropTypes.func,
  handlePrintClick: PropTypes.func,
  isContainWO: PropTypes.bool,
  loading: PropTypes.bool,
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  printLoading: PropTypes.bool,
  printOrderReceipt: PropTypes.func,
  purchaseOrderListData: PropTypes.object.isRequired,
  reactTable: PropTypes.object,
  selectedOrder: PropTypes.object,
  setPrintTypeOption: PropTypes.func,
  setShowReceiptOption: PropTypes.func,
  setShowStatusOption: PropTypes.func,
  showCloseConfirm: PropTypes.bool,
  showCloseModel: PropTypes.bool,
  showDeleteConfirm: PropTypes.bool,
  showDeleteModel: PropTypes.bool,
  toDateMin: PropTypes.object,
  handleSiteChange: PropTypes.func,
};

ManagePurchaseOrderComponent.defaultProps = {
  assignItemsVendorData: [],
  checkPrintType: false,
  clearFilters: () => {},
  closeDeleteOrderConfirm: () => {},
  closeOrderConfirm: () => {},
  closing: false,
  columns: [],
  deletePOWOReceiptLoading: false,
  eleFileDownloadMsg: '',
  fromDateMax: null,
  gridPreferenceLoading: false,
  gridPreferenceSubmitting: false,
  handleVendorChange: () => {},
  handleCloseDialog: () => {},
  handleDeleteDialog: () => {},
  handleEleFileDownload: () => {},
  handleEleFileMsgDialog: () => {},
  handlePrintClick: () => {},
  isContainWO: false,
  loading: false,
  onChangeOfFromDT: () => {},
  onChangeOfToDT: () => {},
  printLoading: false,
  printOrderReceipt: () => {},
  purchaseOrderListData: PropTypes.object.isRequired,
  reactTable: null,
  selectedOrder: null,
  setPrintTypeOption: () => {},
  setShowReceiptOption: () => {},
  setShowStatusOption: () => {},
  showCloseConfirm: false,
  showCloseModel: false,
  showDeleteConfirm: false,
  showDeleteModel: false,
  toDateMin: null,
  handleSiteChange: () => {},
};

export default ManagePurchaseOrderComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/components/managePurchaseOrderList/ManagePurchaseOrder.js